var React = require('react');

function EMarketing (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 6c0-1.105.9-2 1.992-2H16l4 4v10.997A1.998 1.998 0 0 1 18.008 21H6.992C5.892 21 5 20.11 5 19V6zM7 7V18c0 .552.446.999.996.999h9.008c.551 0 .996-.446.996-.995V9l-3-3H7.997C7.453 6 7 6.447 7 6.999zm5.7 1.645l3.672 2.756a.32.32 0 0 1 .128.256v4.524a.32.32 0 0 1-.32.32h-2.325a.32.32 0 0 1-.32-.32v-1.242a.32.32 0 0 0-.32-.32h-1.43a.32.32 0 0 0-.32.32v1.242a.32.32 0 0 1-.32.32H8.82a.32.32 0 0 1-.32-.32v-4.523c0-.101.048-.196.128-.257l3.688-2.756a.32.32 0 0 1 .384 0zm-4.2.176v1.68l2-1.503V8.82a.32.32 0 0 0-.32-.32H8.82a.32.32 0 0 0-.32.32z","fill":"currentColor"}));
}

EMarketing.defaultProps = {"width":"25","height":"25"};

module.exports = EMarketing;

EMarketing.default = EMarketing;
